@if (visible()) {
<div class="no-messages-banner" [class.low-messages]="status() === 'low'" role="alert">
    <i class="pi pi-exclamation-triangle banner-icon"></i>
    <!-- columna de texto: el aviso y, si se le acaban antes de tiempo, la sugerencia de subir de categoría -->
    <div class="banner-body">
        @if (status() === 'low') {
        <p class="banner-text">
            <b>Te quedan pocos mensajes ({{ available() }}).</b>
            Cuando se terminen no vas a poder enviar mensajes desde la plataforma y el agente no va a poder responder por WhatsApp.
            Podés comprar un paquete para no quedarte sin.
        </p>
        } @else {
        <p class="banner-text">
            <b>Te quedaste sin mensajes.</b>
            No podés enviar mensajes desde la plataforma y el agente no puede responder por WhatsApp
            hasta que se renueve tu suscripción o compres un paquete de mensajes.
        </p>
        }
        @if (upgrade(); as sugerencia) {
        <p class="banner-text banner-upgrade">
            Faltan {{ sugerencia.dias }} días para tu próximo cobro: si te pasa seguido, puede convenirte subir a <b>{{ sugerencia.categoria }}</b>.
        </p>
        }
    </div>
    @if (upgrade(); as sugerencia) {
    <a [routerLink]="sugerencia.link" [queryParams]="{ email: sugerencia.email }" class="banner-action banner-action-secondary">Ver categorías</a>
    }
    <a routerLink="/message-packages" class="banner-action">Comprar mensajes</a>
    <button type="button" class="banner-close" (click)="dismiss()" title="Ocultar aviso" aria-label="Ocultar aviso">
        <i class="pi pi-times"></i>
    </button>
</div>
}
